import React, { createContext, useState, useEffect } from "react";
import authService from "../services/authService";
import {jwtDecode} from "jwt-decode";


export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [magazine, setMagazine] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    const magazine = JSON.parse(localStorage.getItem("magazine"));

    if (token && user) {
      setToken(token);
      setUser(user);
      setMagazine(magazine);
    }

    setLoading(false); // Done loading

  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("magazine");
    setUser(null);
    setToken(null);
    setMagazine(null);
    setLoading(false);
  };


  return (
    <AuthContext.Provider value={{ user, setUser,token, setToken,magazine, setMagazine,loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};